import React, { useState } from "react";
import { useTable, usePagination, useRowSelect } from "react-table";
import double_before from "../../../../assets/vw/svg/double-before.svg";
import before from "../../../../assets/vw/svg/before.svg";
import after from "../../../../assets/vw/svg/after.svg";
import double_after from "../../../../assets/vw/svg/double-after.svg";
import DropDown from "../../../../components/Dropdown";
import SEARCH from "../../../../assets/vw/svg/search.svg";
import reenviar_icon from "../../../../assets/vw/svg/reenviar.svg";
import success_icono from "../../../../assets/vw/svg/check-exito.svg";
import error_icono from "../../../../assets/vw/svg/check-error.svg";
import cerrar from "../../../../assets/vw/svg/cerrar.svg";
import Loading from "../../../../components/Loading";
import Cards from "../Cards";


const IndeterminateCheckbox = React.forwardRef(
  ({ indeterminate, ...rest }, ref) => {
    const defaultRef = React.useRef();
    const resolvedRef = ref || defaultRef;
    React.useEffect(() => {
      resolvedRef.current.indeterminate = indeterminate;
    }, [resolvedRef, indeterminate]);
    return (
      <>
        <input
          type="checkbox"
          className="checkbox-round"
          ref={resolvedRef}
          {...rest}
        />
      </>
    );
  }
);

const Table = ({ columns, data, servicio, handleChange, onSuccessReenviar }) => {
  const [cargando, setCargando] = useState(false);
  const [limit, setLimit] = useState(10);
  const [mostrarModal, setMostrarModal] = useState(false);
  const [mensajeModal, setMensajeModal] = useState("");
  const [successReenviar, setSuccessReenviar] = useState(false);
  const [errorReenviar, setErrorReenviar] = useState(false);

  const limitMostrar = ["Mostrar 15", "Mostrar 30", "Mostrar 50", "Todo"];
  const [searchInput, setSearchInput] = useState("");
  const [showGrid, setShowGrid] = useState(false);
  const [selectGrid, setSelectGrid] = useState([]);
  const [selectAllGrid, setSelectAllGrid] = useState(false);

  const api = process.env.REACT_APP_URL_DTO_AVP + "soporte?tipo=erroresSF";

  const searchText = (e) => {
    setSearchInput(e.target.value);
    handleChange(e);
  }

  const optionLimit = (textoLimit) => {
    switch (textoLimit) {
      case "Mostrar 15":
        return 15;
      case "Mostrar 30":
        return 30;
      case "Mostrar 50":
        return 50;
      case "Todo":
        return data.length;
      default:
        return data.length;
    }
  };

  const handleReenviar = (e) => {
    const filaDirecta = e?.row || null;

    if (filaDirecta) {
      reenviar([filaDirecta]);
      return;
    }
    if (selectedFlatRows.length > 0) {
      reenviar(selectedFlatRows.map(r => r.original));
      return;
    }
    if (selectGrid.length > 0) {
      reenviar(selectGrid);
    }
  };

  const reenviar = (registros) => {
    setCargando(true);

    const body = {
      registros: registros.map(item => ({
        idCuentaContacto: item.idCuentaContacto,
        correo: item.correo,
        estadoCorreo: item.estadoCorreo,
        estadoAceptacionUsuario: item.estadoAceptacionUsuario,
        fechaAceptacion: item.fechaAceptacion,
        fechaEntregaCorreo: item.fechaEntregaCorreo
      }))
    };

    fetch(api, {
      method: "POST",
      headers: {
        Authorization: "Bearer " + servicio.getToken(),
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
    })
      .then(async (res) => {
        let responseBody = await res.json();
        if (!res.ok) throw new Error(responseBody.mensaje);

        setCargando(false);
        setMensajeModal("El reenvio ha sido exitoso");
        setSuccessReenviar(true);
        setErrorReenviar(false);
        setMostrarModal(true);
        setSelectGrid([]);
        setSelectAllGrid(false);
        onSuccessReenviar();
      })
      .catch((errorP) => {
        setCargando(false);
        setSuccessReenviar(false);
        setMensajeModal("Ha ocurrido un error\n" + errorP.message);
        setErrorReenviar(true);
        setMostrarModal(true);
      });
  }

  const onChangeGrid = (value) => {
    setShowGrid(value);
    setSelectGrid([]);
    setSelectAllGrid(false)
    toggleAllRowsSelected(false);
  };

  const selects = (avisoprivacidad, tipo) => {
    if (tipo === "push") {
      setSelectGrid([...selectGrid, avisoprivacidad]);
    } else if (tipo === "pop") {
      let idCuentaContacto = avisoprivacidad.idCuentaContacto;
      setSelectGrid((l) => l.filter((item) => item.idCuentaContacto !== idCuentaContacto));
    }
  };

  const gridAvisoPrivacidad = (page) => {
    const selectCheck = (e, index) => {
      const avisoprivacidad = page[index].original;

      if (e.target.checked) {
        setSelectGrid(prev => [...prev, avisoprivacidad]);
      } else {
        setSelectGrid(prev =>
          prev.filter(
            item => item.idCuentaContacto !== avisoprivacidad.idCuentaContacto
          )
        );
        setSelectAllGrid(false);
      }
    };


    return (
      <div className="grid__view row">
        {page.map((avisoprivacidad, index) => {
          return (
            <div className="col-3 mb-3" key={index}>
              <div className="card_grid">
                <div className="d-flex">
                  <div className="container_id">{""}</div>
                  <div key={"select-" + index} className="ms-auto">
                    <input
                      key={"select-" + index}
                      type="checkbox"
                      className="checkbox-round mx-1"
                      id={"select-" + index}
                      value={""}
                      checked={selectGrid.some(
                        item => item.idCuentaContacto === avisoprivacidad.original.idCuentaContacto
                      )}
                      onChange={(e) => selectCheck(e, index)}
                    />
                  </div>
                </div>

                <div className="d-flex align-items-start flex-column mx-3 mt-3 size-card">
                  <div
                    className="onclick w-100 d-flex flex-column align-items-left"
                  >
                    <div className="title_card ps-2">
                      {avisoprivacidad.original.idCuentaContacto.length > 20 ? `${avisoprivacidad.original.idCuentaContacto.substring(0, 18)}…` : avisoprivacidad.original.idCuentaContacto}
                    </div>
                    <div className="title_card ps-2">
                      {avisoprivacidad.original.marca.length > 20 ? `${avisoprivacidad.original.marca.substring(0, 18)}…` : avisoprivacidad.original.marca}
                    </div>
                  </div>
                  <div>
                    <div className={` tooltip_vw`}
                      onClick={(e) => {
                        e.row = avisoprivacidad.original;
                        handleReenviar(e);
                      }}                    >
                      <img src={reenviar_icon} alt="menu"></img>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    );
  };

  const finalColumns = React.useMemo(
    () => [
      ...columns,
      {
        Header: "Acciones",
        id: "acciones",
        Cell: ({ row }) => (
          <div
            className="tooltip_vw"
            style={{ cursor: "pointer" }}
            onClick={(e) => {
              e.row = row.original;
              handleReenviar(e);
            }}
          >
            <img src={reenviar_icon} alt="menu" />
          </div>
        ),
      },
    ],
    [columns]
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    page,
    canPreviousPage,
    canNextPage,
    pageOptions,
    pageCount,
    gotoPage,
    nextPage,
    previousPage,
    selectedFlatRows,
    setPageSize,
    state: { pageIndex },
    toggleAllRowsSelected,
  } = useTable(
    {
      columns: finalColumns,
      data,
      initialState: { pageSize: 15 },
    },
    usePagination,
    useRowSelect,
    (hooks) => {
      hooks.visibleColumns.push((columns) => [
        {
          id: "selection",
          Header: ({ getToggleAllPageRowsSelectedProps }) => (
            <div>
              <IndeterminateCheckbox {...getToggleAllPageRowsSelectedProps()} />
            </div>
          ),
          Cell: ({ row }) => (
            <div>
              <IndeterminateCheckbox {...row.getToggleRowSelectedProps()} />
            </div>
          ),
        },
        ...columns,
      ]);
    }
  );

  const NavigationControl = () => {
    return (
      <div className="btn-group btn-group-controls" role="group" aria-label="First group">
        <button
          onClick={() => gotoPage(0)}
          disabled={!canPreviousPage}
          className={
            "btn btn-secondary btn__secondary-- btn_pagination"
          }
        >
          <img src={double_before} alt="first" />
        </button>
        {" "}
        <button
          onClick={() => previousPage()}
          disabled={!canPreviousPage}
          className={
            "btn btn-secondary btn__secondary-- btn_pagination"
          }
        >
          <img src={before} alt="before" />
        </button>
        {" "}
        <div className="num_pagination py-3">
          {pageIndex + 1} de {pageOptions.length}
        </div>
        <button
          onClick={() => nextPage()}
          disabled={!canNextPage}
          className={
            "btn btn-secondary btn__secondary-- btn_pagination"
          }
        >
          <img src={after} alt="after" />
        </button>
        {" "}
        <button
          onClick={() => gotoPage(pageCount - 1)}
          disabled={!canNextPage}
          className={
            "btn btn-secondary btn__secondary-- btn_pagination"
          }
        >
          <img src={double_after} alt="last" />
        </button>
        {" "}
      </div>
    );
  }

  const buildPopUp = () => {
    return (
      <div
        className={`modal modal_vw modal_popup_vw fade ${mostrarModal ? "show" : ""}`}
        id="archivar"
        data-keyboard="false"
        data-backdrop="static"
        tabIndex="-1"
        aria-labelledby="archivarLabel"
        style={mostrarModal ? { display: "block" } : {}}
        aria-modal="true"
        role="dialog"
      >
        <div className="modal-dialog modal-dialog-centered modal_popup_content">
          <div className="modal-content modal_content-vw">
            <div className="modal-header modal_header-vw">
              <div className="d-flex justify-content-end">
                <button
                  className="button_icon-vw"
                  type="button"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  onClick={() => {
                    setMostrarModal(false);
                  }}
                >
                  <img src={cerrar} alt="cerrar"></img>
                </button>
              </div>
            </div>
            <div className={`modal-body p-3 p-sm-5 p-lg-5`}>
              {successReenviar ? (
                <div className="mt-0 mt-lg-2 px-2 mensaje_confirmacion mb-0 mb-sm-5">
                  <div className="d-flex justify-content-center">
                    <img
                      src={success_icono}
                      className="icono-mensaje"
                      alt="exito"
                    ></img>
                  </div>
                  <label className="popup_title popup_title--status d-flex justify-content-center">
                    {mensajeModal}
                  </label>
                </div>
              ) : errorReenviar ? (
                <div className="mt-0 mt-lg-2 px-2 mensaje_confirmacion mb-0 mb-sm-5">
                  <div className="d-flex justify-content-center">
                    <img
                      src={error_icono}
                      className="icono-mensaje"
                      alt="error"
                    ></img>
                  </div>
                  <label
                    className="popup_title popup_title--status d-flex justify-content-center"
                    dangerouslySetInnerHTML={{ __html: mensajeModal.replace(/\n/g, "<br>") }}
                  />
                </div>
              ) : (
                <div className="mt-0 mt-lg-2 px-2 mensaje_confirmacion mb-0 mb-sm-5">
                  <label className="popup_title d-flex justify-content-center">
                    {mensajeModal}
                  </label>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  };

  return cargando ? (
    <Loading />
  ) : (
    <>
      <div className="content main-content-container">
        <div className="main-content-actions row m-0 py-2">
          <div className="col-7 col-sm-6 col-lg-3 wrapper m-0 p-0 ">
            <input
              className="input_vw"
              name="searchInput"
              value={searchInput || ""}
              onChange={(e) => {
                searchText(e);
              }}
              placeholder="Busca por ID, nombre, número…."
            />
            <span className="pt-2 ps-1">
              <img src={SEARCH} alt="buscar" className="icono-menu me-3" />
            </span>
          </div>

          <div className="d-flex col-1 col-sm-1 col-lg-3">
            {selectedFlatRows.length > 0 || selectGrid.length > 0 ? (
              <button
                type="button"
                className={"button_vw button_vw--reenviar-azul button_reenviar_item"}
                onClick={handleReenviar}
              >
                <div className={"reenviar-icon"}></div>
                <span className={"ml-2"}>Reenviar</span>
              </button>
            ) : (
              ""
            )}
          </div>

          <div className="col-3 col-sm-5 col-lg-6 p-0">
            <div className="d-flex justify-content-end align-items-center">
              <div className={`view_select_all ${showGrid ? 'icon_grid_active' : ''} ms-auto align-self-center`}>
                <input
                  type="checkbox"
                  className="checkbox-round mx-1"
                  checked={selectAllGrid}
                  onChange={(e) => {
                    const checked = e.target.checked;
                    setSelectAllGrid(checked);

                    if (checked) {
                      setSelectGrid(page.map(row => row.original));
                    } else {
                      setSelectGrid([]);
                    }
                  }}
                />
              </div>
              <div className="view__options">
                <button
                  className="button_icon-vw kit_icon"
                  type="button"
                  onClick={() => onChangeGrid(true)}
                >
                  <span
                    className={`${showGrid ? "icon-grid-active" : "icon-grid"}`}
                  >
                    {" "}
                  </span>
                </button>
                <button
                  className="button_icon-vw kit_icon"
                  type="button"
                  onClick={() => onChangeGrid(false)}
                >
                  <span
                    className={`${!showGrid ? "icon-table-active" : "icon-table"
                      }`}
                  >
                    {" "}
                  </span>
                </button>
              </div>
              <div className="">
                <DropDown
                  menu={limitMostrar}
                  title={limitMostrar[0]}
                  inputField={limit}
                  handleOptionSelected={(e) => {
                    const limitInt = optionLimit(e);
                    setLimit(limitInt);
                    setPageSize(Number(limitInt));
                  }}
                />
              </div>
              <NavigationControl />
            </div>
          </div>
        </div>
      </div>

      <Cards
        page={page}
        handleReenviar={handleReenviar}
        selects={selects}
        NavigationControl={NavigationControl}
        selectAllGrid={selectAllGrid}
        selectGrid={selectGrid}
        setSelectGrid={setSelectGrid}
      />

      {showGrid ? (
        gridAvisoPrivacidad(page)
      ) : (
        <div
          className="table-responsive"
          style={{
            overflowY: 'hidden'
          }}
        >
          <table
            {...getTableProps()}
            className="table table-striped table-responsive tabla_contenido_vw"
            id="table-avisoprivacidad"
          >
            <thead className="thead-dark">
              {headerGroups.map((headerGroup) => (
                <tr
                  {...headerGroup.getHeaderGroupProps()}
                  className="thead__titulo"
                >
                  {headerGroup.headers.map((column) => (
                    <th {...column.getHeaderProps()}>
                      {column.render("Header")}
                    </th>
                  ))}
                </tr>
              ))}
            </thead>
            <tbody {...getTableBodyProps()} className="tbody-table">
              {page.map((row) => {
                prepareRow(row);
                return (
                  <tr {...row.getRowProps()} className="table-tr-check">
                    {row.cells.map((cell, cellId) => {
                      return (
                        <td {...cell.getCellProps()}>
                          {cell.render("Cell")}{" "}
                        </td>
                      );
                    })}
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
      {buildPopUp()}
    </>
  );
}

const Tabla = (props) => {
  const columns = React.useMemo(
    () => [
      {
        Header: "ID",
        accessor: "idCuentaContacto",
      },
      {
        Header: "Marca",
        accessor: "marca",
      },
      {
        Header: "Fecha aceptación",
        accessor: "fechaAceptacion",
      },
      {
        Header: "Estado SF",
        accessor: "estadoAceptacionSF",
      },
      {
        Header: "Estado usuario",
        accessor: "estadoAceptacionUsuario",
      },
    ],
    []
  );
  return (
    <>
      <Table
        columns={columns}
        data={props.avisos}
        servicio={props.servicio}
        handleChange={props.handleChange}
        onSuccessReenviar={props.onSuccessReenviar}
      />
    </>
  );
}

export default Tabla;
